import { CustomState } from "@iewccouk/Store/Reducers";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum widgetFields {
    defaultRegularUpdatesToYes = "defaultRegularUpdatesToYes",
}

interface OwnProps extends WidgetProps {
    fields: {
        [widgetFields.defaultRegularUpdatesToYes]?: boolean;
    };
}

const mapStateToProps = (state: CustomState) => {
    const fieldName = "regularUpdates";
    return {
        fieldName,
        fieldValue: state.components.contactUsForm.fieldValues[fieldName],
    };
};

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

function regularUpdatesFieldInitialFromSettings(raw: boolean | undefined): "true" | "false" {
    if (raw === true) {
        return "true";
    }
    if (String(raw).toLowerCase() === "true") {
        return "true";
    }
    return "false";
}

export interface FormFieldStyles {
    radioGroup?: RadioGroupProps;
}

export const formFieldStyles: FormFieldStyles = {
    radioGroup: {
        css: css`
            legend {
                font-size: 16px;
                line-height: 26px;
            }
        `,
    },
};

const styles = formFieldStyles;

const RegularUpdates: React.FC<Props> = ({ fieldName, fieldValue, setFieldValue, fields }) => {
    const initial = regularUpdatesFieldInitialFromSettings(fields[widgetFields.defaultRegularUpdatesToYes]);

    React.useEffect(() => {
        if (!fieldValue) {
            setFieldValue({ key: fieldName, value: initial });
        }
    }, [fieldValue, fieldName, setFieldValue, initial]);

    return (
        <RadioGroup
            {...styles.radioGroup}
            onChange={(e: any) => setFieldValue({ key: fieldName, value: e.target.value })}
            value={fieldValue}
            label={`${translate("Sign up for regular updates from Anixter?")}`}
        >
            <Radio value="true">{translate("Yes, I would like to sign up")}</Radio>
            <Radio value="false">{translate("No, I am not ready to sign up")}</Radio>
        </RadioGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RegularUpdates) as any,
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: widgetFields.defaultRegularUpdatesToYes,
                displayName: "Pre-select 'Yes' for sign up to regular updates",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
            },
        ],
    },
};

export default widgetModule;
